/**
 * Hook for shipment data operations
 */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectShipmentData, selectShipmentItems, selectProductSkuUpcList, selectKitComponentProducts, selectShipmentPackages, selectPackageContentBySeqId, selectShipmentItemSourceList } from '../../../redux/packing';
export var useShipmentData = function () {
    var shipmentData = useSelector(selectShipmentData);
    var shipmentItems = useSelector(selectShipmentItems);
    var shipmentItemSources = useSelector(selectShipmentItemSourceList);
    var productSkuUpcList = useSelector(selectProductSkuUpcList);
    var kitComponentProducts = useSelector(selectKitComponentProducts);
    var shipmentPackages = useSelector(selectShipmentPackages);
    var packageContentBySeqId = useSelector(selectPackageContentBySeqId);
    // Find product by ID, SKU, or UPC
    // Note: Should we use lower case for comparison?
    // Other parts of the existing code do that intermittingly
    // - Marwan
    var findProductByIdOrSku = useCallback(function (scanInput) {
        if (!scanInput)
            return null;
        // const lowerInput = scanInput.toLowerCase()
        return productSkuUpcList.find(function (item) {
            return item.productId === scanInput ||
                item.productSku === scanInput ||
                item.productUpc === scanInput;
        }
        // item.productId?.toLowerCase() === lowerInput ||
        // item.productSku?.toLowerCase() === lowerInput ||
        // item.productUpc?.toLowerCase() === lowerInput
        );
    }, [productSkuUpcList]);
    // Find kit product by ID, SKU, or UPC
    // Note: Should we use lower case for comparison?
    // Other parts of the existing code do that intermittingly
    // - Marwan
    var findKitProductByIdOrSku = useCallback(function (scanInput) {
        if (!scanInput)
            return null;
        // const lowerInput = scanInput.toLowerCase()
        return kitComponentProducts.find(function (item) {
            return item.componentProductId === scanInput ||
                item.sku === scanInput ||
                item.upc === scanInput ||
                item.productSku === scanInput ||
                item.productUpc === scanInput ||
                item.productId === scanInput;
        }
        // item.componentProductId?.toLowerCase() === lowerInput ||
        // item.sku?.toLowerCase() === lowerInput ||
        // item.upc?.toLowerCase() === lowerInput ||
        // item.productSku?.toLowerCase() === lowerInput ||
        // item.productUpc?.toLowerCase() === lowerInput ||
        //item.productId?.toLowerCase() === lowerInput
        );
    }, [kitComponentProducts]);
    // Get packed quantity for a product across all packages
    var getPackedQuantityForProduct = useCallback(function (productId) {
        var packedQty = 0;
        Object.values(packageContentBySeqId).forEach(function (contents) {
            contents.forEach(function (content) {
                if (content.productId === productId) {
                    packedQty += content.quantity;
                }
            });
        });
        return packedQty;
    }, [packageContentBySeqId]);
    // Get total items count
    var getTotalItemsCount = useCallback(function () {
        var total = 0;
        var packed = 0;
        // Use aggregated values to ensure we count correctly
        // Or iterate sources which is what we do here
        shipmentItemSources.forEach(function (item) {
            var _a, _b, _c;
            total += (_a = item.quantity) !== null && _a !== void 0 ? _a : 0;
            packed += ((_b = item.quantity) !== null && _b !== void 0 ? _b : 0) - ((_c = item.quantityNotHandled) !== null && _c !== void 0 ? _c : 0);
        });
        return {
            total: total,
            packed: packed,
            remaining: total - packed
        };
    }, [shipmentItemSources]);
    // Check if shipment has serialized products
    var hasSerializedProducts = useCallback(function () {
        return productSkuUpcList.some(function (item) { return item.serialized === 'Y'; });
    }, [productSkuUpcList]);
    return {
        shipmentData: shipmentData,
        shipmentItems: shipmentItems,
        shipmentPackages: shipmentPackages,
        findProductByIdOrSku: findProductByIdOrSku,
        findKitProductByIdOrSku: findKitProductByIdOrSku,
        getPackedQuantityForProduct: getPackedQuantityForProduct,
        getTotalItemsCount: getTotalItemsCount,
        hasSerializedProducts: hasSerializedProducts
    };
};
export default useShipmentData;
